import { tv } from "../../variants/tv.js";
const ImageVariants_image = tv({
    base: 'object-cover',
    variants: {
        isSvg: {
            true: 'object-contain'
        },
        width: {
            4: 'w-4',
            5: 'w-5',
            6: 'w-6',
            8: 'w-8',
            10: 'w-10',
            12: 'w-12',
            14: 'w-14',
            16: 'w-16',
            18: 'w-18',
            20: 'w-20',
            22: 'w-22',
            24: 'w-24',
            28: 'w-28',
            32: 'w-32',
            40: 'w-40',
            48: 'w-48',
            56: 'w-56',
            64: 'w-64',
            80: 'w-80',
            112: 'w-112',
            128: 'w-128',
            160: 'w-160',
            240: 'w-240',
            320: 'w-320',
            auto: 'w-auto',
            full: 'w-full'
        },
        height: {
            4: 'h-4',
            5: 'h-5',
            6: 'h-6',
            8: 'h-8',
            10: 'h-10',
            12: 'h-12',
            14: 'h-14',
            16: 'h-16',
            18: 'h-18',
            20: 'h-20',
            22: 'h-22',
            24: 'h-24',
            28: 'h-28',
            32: 'h-32',
            40: 'h-40',
            48: 'h-48',
            56: 'h-56',
            64: 'h-64',
            80: 'h-80',
            112: 'h-112',
            128: 'h-128',
            160: 'h-160',
            240: 'h-240',
            320: 'h-320',
            auto: 'h-auto',
            full: 'h-full'
        },
        maxWidth: {
            4: 'max-w-4',
            6: 'max-w-6',
            8: 'max-w-8',
            10: 'max-w-10',
            12: 'max-w-12',
            14: 'max-w-14',
            16: 'max-w-16',
            18: 'max-w-18',
            20: 'max-w-20',
            22: 'max-w-22',
            24: 'max-w-24',
            28: 'max-w-28',
            32: 'max-w-32',
            40: 'max-w-40',
            48: 'max-w-48',
            56: 'max-w-56',
            64: 'max-w-64',
            80: 'max-w-80',
            112: 'max-w-112',
            128: 'max-w-128',
            160: 'max-w-160',
            240: 'max-w-240',
            320: 'max-w-320',
            none: 'max-w-none',
            full: 'max-w-full',
            xs: 'max-w-xs',
            sm: 'max-w-sm',
            md: 'max-w-md',
            lg: 'max-w-lg',
            xl: 'max-w-xl',
            '2xl': 'max-w-2xl',
            '3xl': 'max-w-3xl',
            '4xl': 'max-w-4xl',
            '5xl': 'max-w-5xl',
            '6xl': 'max-w-6xl',
            '7xl': 'max-w-7xl'
        },
        maxHeight: {
            4: 'max-h-4',
            6: 'max-h-6',
            8: 'max-h-8',
            10: 'max-h-10',
            12: 'max-h-12',
            14: 'max-h-14',
            16: 'max-h-16',
            18: 'max-h-18',
            20: 'max-h-20',
            22: 'max-h-22',
            24: 'max-h-24',
            28: 'max-h-28',
            32: 'max-h-32',
            40: 'max-h-40',
            48: 'max-h-48',
            56: 'max-h-56',
            64: 'max-h-64',
            80: 'max-h-80',
            112: 'max-h-112',
            128: 'max-h-128',
            160: 'max-h-160',
            240: 'max-h-240',
            320: 'max-h-320',
            none: 'max-h-none',
            full: 'max-h-full',
            screen: 'max-h-screen'
        },
        ratio: {
            '1/1': 'aspect-1/1',
            '3/2': 'aspect-3/2',
            '2/3': 'aspect-2/3',
            '4/3': 'aspect-4/3',
            '3/4': 'aspect-3/4',
            '16/9': 'aspect-16/9',
            '9/16': 'aspect-9/16',
            '21/9': 'aspect-21/9',
            '32/9': 'aspect-32/9',
            auto: 'auto'
        },
        borderRadius: {
            none: 'rounded-none',
            xs: 'rounded-xsm',
            sm: 'rounded-sm',
            md: 'rounded-md',
            lg: 'rounded-lg',
            xl: 'rounded-xl',
            '2xl': 'rounded-2xl',
            '3xl': 'rounded-3xl',
            full: 'rounded-full'
        },
        shadow: {
            none: '',
            sm: 'shadow-sm',
            md: 'shadow-md',
            lg: 'shadow-lg',
            xl: 'shadow-xl',
            '2xl': 'shadow-xl',
            hover: 'transition-shadow duration-300 hover:shadow-lg'
        },
        objectFit: {
            contain: 'object-contain',
            cover: 'object-cover',
            none: 'object-none'
        },
        objectPosition: {
            bottom: 'object-bottom',
            top: 'object-top',
            center: 'object-center',
            left: 'object-left',
            right: 'object-right'
        },
        isLoading: {
            true: 'animate-pulse bg-neutral-4',
            false: ''
        }
    },
    compoundVariants: [
        {
            width: 'full',
            height: 'full',
            class: 'h-full w-full'
        },
        {
            width: 'full',
            class: 'w-full'
        },
        {
            height: 'full',
            class: 'h-full'
        },
        {
            isSvg: true,
            class: 'object-contain'
        }
    ],
    defaultVariants: {
        width: 'auto',
        height: 'auto',
        borderRadius: 'none',
        ratio: 'auto',
        shadow: 'none',
        objectFit: 'cover',
        objectPosition: 'center',
        isLoading: false,
        isSvg: false
    }
});
export { ImageVariants_image as image };
